<template>
  <div v-if="product.brand && !isDns && !noImage" class="ssl-card-brand">
    <img :src="`/static/images/brand/${product.brand}.png`" :alt="product.name" />
  </div>
  <h3 class="ssl-card-title">
    <NuxtLink :to="localePath(`/product/${product.code}`)">{{ product.name }}</NuxtLink>
  </h3>
  <div class="ssl-card-features">
    <template v-if="isCloudCodeSigning">
      <div class="ssl-card-feature">{{ t('numSignatures') }}: {{ product.feat5 }} {{ t('perYear') }}</div>
      <div class="ssl-card-feature" v-for="feat in plainTm('productDesc.cloudCodeSigning')" :key="feat">
        {{ feat }}
      </div>
    </template>
    <template v-if="isVmc">
      <div class="ssl-card-feature" v-for="feat in plainTm('productDesc.vmc')" :key="feat">
        {{ feat }}
      </div>
    </template>
    <template v-if="isDns">
      <div class="ssl-card-feature" v-for="feat in plainTm('productDesc.dns')" :key="feat">
        {{ feat }}
      </div>
    </template>
    <template v-if="isSever"> </template>
    <template v-else>
      <div class="ssl-card-feature" v-if="product.feat1">
        {{ product.feat1 }}
      </div>
      <div class="ssl-card-feature" v-if="product.feat2">
        {{ product.feat2 }}
      </div>
      <div class="ssl-card-feature" v-if="product.feat3">
        {{ product.feat3 }}
      </div>
      <div class="ssl-card-feature" v-if="product.feat4">
        {{ product.feat4 }}
      </div>
    </template>
  </div>
  <div class="ssl-card-price">
    <template v-if="isSever">
      <span class="ssl-card-current">{{ product.currency }}{{ getPrice }} {{ getUnit }}</span>
      <span class="ssl-card-discount" v-if="product.discountRatio">{{ product.discountRatio }} Off</span>
      <span class="ssl-card-discount" v-else>{{ discountPercent(getMarketPrice, getPrice) }}% Off</span>
    </template>
    <template v-else>
      <span class="ssl-card-current">{{ product.currency }}{{ formatPrice(product.buyPrice) }}/yr</span>
      <span class="ssl-card-discount" v-if="product.discountRatio">{{ product.discountRatio }} Off</span>
      <span class="ssl-card-discount" v-else>{{ discountPercent(product.marketPrice, product.buyPrice) }}% Off</span>
    </template>
  </div>
  <div class="ssl-card-original">{{ product.currency }}{{ getMarketPrice }} {{ getUnit }}</div>
  <div class="mt20 mb10">
    <a
      class="btn"
      :href="`https://console.nicsrs.com/product/config/${product.code}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ t('btnText.buyNow') }}
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const { t, tm, rt, locale } = useI18n()
const { plainTm } = usePlainTm()
const props = defineProps({
  product: { type: Object, required: true },
  isCloudCodeSigning: { type: Boolean, required: false },
  isVmc: { type: Boolean, required: false },
  isDns: { type: Boolean, required: false },
  isSever: { type: Boolean, required: false },
  pleskType: { type: String, required: false },
  annualPriceMap: { type: Object, required: false, default: () => ({}) },
  noImage: { type: Boolean, required: false }
})

function formatPrice(val) {
  return val != null ? Number(val).toFixed(2) : '0.00'
}
function discountPercent(listprice, price) {
  const p = Number(price || 0)
  const l = Number(listprice || 0)
  if (!l || l <= p) return 0
  return (((l - p) / l) * 100).toFixed(2)
}
const getPrice = ref(props.product.buyPrice)
const getMarketPrice = ref(props.product.marketPrice)
const getUnit = ref(props.pleskType === 'month' ? '/mo' : '/yr')

watch(
  () => props.pleskType,
  (val) => {
    const hasAnnualMap = props.annualPriceMap?.[props.product.code] != null
    if (hasAnnualMap) {
      // sitelock: 月价从接口 buyPrice，年价从 annualPriceMap 硬编码
      if (val === 'month') {
        getPrice.value = Number(props.product.buyPrice).toFixed(2)
        getMarketPrice.value = Number(props.product.marketPrice).toFixed(2)
      } else {
        getPrice.value = Number(props.annualPriceMap[props.product.code]).toFixed(2)
        getMarketPrice.value = (Number(props.product.marketPrice) * 12).toFixed(2)
      }
    } else {
      // 其他产品: 原有逻辑 buyPrice 为年价
      if (val === 'month') {
        getPrice.value = (Number(props.product.buyPrice) / 12).toFixed(2)
        getMarketPrice.value = (Number(props.product.marketPrice) / 12).toFixed(2)
      } else {
        getPrice.value = Number(props.product.buyPrice).toFixed(2)
        getMarketPrice.value = Number(props.product.marketPrice).toFixed(2)
      }
    }
    getUnit.value = val === 'month' ? '/mo' : '/yr'
  },
  { immediate: true }
)
</script>
